<template>
  <div @click="flipCard" class="card" :class="{ isFlipped: card.flipped }">
    <div class="front">
      <img src="../assets/cards/blue_back.jpg" />
    </div>
    <div class="back">
      <img v-bind:src="image" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["card"],
  data: function() {
    return {};
  },
  computed: {
    image: function() {
      return require("../assets/cards/" + this.card.value + ".jpg");
    }
  },
  methods: {
    flipCard: function() {
      this.$emit("cardClick", this.$attrs.position);
    }
  }
};
</script>

<style>
.card {
  height: 30%;
  width: 30%;
  margin-top: auto;
  margin-bottom: auto;

  /* animation stuff */
  position: relative;
  transition: transform 1s;
  transform-style: preserve-3d;
}

.front,
.back {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  backface-visibility: hidden;
}
.front {
  z-index: 2;
}

.front img,
.back img {
  height: inherit;
}

.back {
  transform: rotateY(180deg);
}

.card.isFlipped {
  transform: rotateY(180deg);
}
</style>
